// extracted by mini-css-extract-plugin
export var deliveryRow = "_q4-a";
export var fixedHeight = "_q4-4";
export var freightLogo = "_q4-9";
export var fullWidth = "_q4-3";
export var priceColumn = "_q4-5";
export var radioSelected = "_q4-7";
export var radioUnselected = "_q4-6";
export var selectedOption = "_q4-2";
export var selectedOptionContainer = "_q4-1";
export var selection = "_q4-0";
export var tallSkeletonText = "_q4-8";